@if (loading()) {
  <app-loading />
} @else {
  @if (podeEditar()) {
    <!-- O seletor oferece SÓ o que o parceiro ainda não alcança: empresa que já vem por deal
         ou por vínculo manual fica de fora, porque vinculá-la seria conceder um direito que
         ela já tem. -->
    <div class="partner-companies__picker">
      <!-- Uma empresa por vez: o vínculo carrega um valor pretendido próprio, e não existe
           um valor que sirva para várias de uma vez. -->
      <app-select
        label="Vincular empresa"
        placeholder="Selecione a empresa a vincular"
        [options]="opcoesDisponiveis()"
        [(ngModel)]="paraVincular" />

      <app-button
        label="Vincular"
        icon="pi pi-link"
        [isLoading]="saving()"
        [disabled]="saving() || !paraVincular"
        (sendButtonClick)="vincular()" />
    </div>

    @if (!opcoesDisponiveis().length && opcoesCarregadas()) {
      <p class="partner-companies__hint">
        Não há empresa disponível para vincular. Uma empresa só pode estar com um parceiro por vez,
        então as que já têm vínculo ou deal de outro parceiro não aparecem aqui.
      </p>
    }
  }

  <!-- `isRowSelectable` desabilita o checkbox nas linhas que só vêm de deal: não há vínculo
       manual para remover ali, e um checkbox marcável que não faz nada só se revela depois
       do clique. -->
  <!-- `dataKey` é OBRIGATÓRIO aqui: o padrão do `app-table` é `'id'`, e estes itens não têm
       `id` — têm `companyId`. Sem isto, toda linha resolve a chave `undefined`, o PrimeNG
       trata todas como a MESMA linha, e marcar um checkbox marca a tabela inteira. -->
  <app-table
    #tabela
    [items]="empresas()"
    [columnDefinitions]="columnDefinitions"
    [dataKey]="'companyId'"
    [hasPagination]="true"
    [inMemoryPagination]="true"
    [rows]="15"
    [rowsPerPageOptions]="[15, 30, 50, 100]"
    [hasCheckbox]="podeEditar()"
    [isRowSelectable]="podeDesvincular"
    (sendTableSelection)="onSelecaoDaLista($event)">
    <ng-template appNamedTemplate="origin" let-item>
      <span
        class="partner-company-origin"
        [class.partner-company-origin--deal]="item.origin === 'Deal'">
        {{ rotuloDaOrigem(item) }}
      </span>
    </ng-template>
  </app-table>

  <!-- Barra flutuante de seleção, mesmo padrão da listagem de empréstimos. Ela só existe
       enquanto há linha marcada, então nunca ocupa espaço à toa nem fica desabilitada na
       tela — que era o problema do botão fixo que ela substituiu. -->
  @if (marcadasNaLista().length) {
    <app-floating-menu
      [items]="acoesDaSelecao()"
      [selectedCountMessage]="mensagemDaSelecao()"
      (clear)="limparSelecao()" />
  }

  @if (!empresas().length) {
    <p class="partner-companies__empty">
      Este parceiro ainda não alcança nenhuma empresa. Ele passa a alcançar uma quando registrar um
      deal, ou quando a Legatus vincular uma aqui.
    </p>
  }
}

<!-- A modal grava o vínculo E o deal; a aba só recarrega depois. -->
<app-modal-vincular-empresa #modalVincular (vinculou)="aoVincular()" />
